import type { ActionContext } from 'vuex'

import type { ActionClass, AppState } from '../../../models'

import { APP_CONSTS } from '../app.consts'

export class SetFullscreenAction implements ActionClass {
  static execute(this: void, { commit }: ActionContext<AppState, any>, fullscreen: boolean): void {
    commit(APP_CONSTS.mutations.setFullscreen, fullscreen)
  }
}
